import { IUser } from 'redux/store/user/types'
import {
  ContractCreationWays,
  ContractStatusUnion
} from 'features/ContractDetails/types'
import { LedByUnion } from '../../ContractCategoryDetails/types'
import { VENDOR_FEE_TYPES_VALUES } from '../constants'

export const isOwnerCondition = (user: IUser) => ({
  'creator.uuid': user.uuid
})

export const isInLedBy = (inLedBy: LedByUnion[]) => ({
  led_by: {
    $in: inLedBy
  }
})

export const isInStatuses = (inStatuses: ContractStatusUnion[]) => ({
  status: {
    $in: inStatuses
  }
})

export const isNotInStatuses = (inStatuses: ContractStatusUnion[]) => ({
  status: {
    $nin: inStatuses
  }
})

export const isResponsibleVendorCondition = (user: IUser) => ({
  vendor_responsibles: {
    $elemMatch: { uuid: user.uuid }
  }
})

export const isResponsibleCommunityCondition = (user: IUser) => ({
  community_responsibles: {
    $elemMatch: {
      uuid: user.uuid
    }
  }
})

export const isOwnerInSameHSCondition = (user: IUser) => ({
  'creator.health_system.uuid': user.health_system
})

export const isResponsibleCommonsCondition = (user: IUser) => ({
  commons_responsibles: {
    $elemMatch: {
      uuid: user.uuid
    }
  }
})

export const isManualContract = () => ({
  creation_way: ContractCreationWays.MANUAL
})

export const isAutoContract = () => ({
  creation_way: ContractCreationWays.AUTO
})
export const isStartDateEmpty = () => ({
  start_date: { $exists: true, $in: [null] }
})

export const isVendorFeeTypeAdmin = () => ({
  vendor_fee_type: VENDOR_FEE_TYPES_VALUES.ADMIN
})

export const isFinishDateEmpty = () => ({
  finish_date: { $exists: true, $in: [null] }
})

export const areStartAndFinishNotEmptyForAuto = () => ({
  start_date: { $ne: null },
  finish_date: { $ne: null },
  creation_way: ContractCreationWays.AUTO
})

export const isSameHealthSystem = (user: IUser) => ({
  'health_systems.uuid': user.health_system
})

export const isSameCommunity = (user: IUser) => ({
  'community.uuid': user.community
})
